import { render, staticRenderFns } from "./Configuration.vue?vue&type=template&id=0d061bb8&scoped=true&"
import script from "./Configuration.vue?vue&type=script&lang=js&"
export * from "./Configuration.vue?vue&type=script&lang=js&"
import style0 from "./Configuration.vue?vue&type=style&index=0&id=0d061bb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d061bb8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d061bb8')) {
      api.createRecord('0d061bb8', component.options)
    } else {
      api.reload('0d061bb8', component.options)
    }
    module.hot.accept("./Configuration.vue?vue&type=template&id=0d061bb8&scoped=true&", function () {
      api.rerender('0d061bb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/serviceDetails/Configuration.vue"
export default component.exports